export default "__VITE_ASSET__D6vQ0JFj__"